import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { apolloClient } from './lib/apollo';
import { initTheme } from './lib/theme';
import App from './App';
// Self-hosted variable fonts (see fontFamily in tailwind.config.js): Fraunces
// for display/headings, Source Serif 4 for reading prose. Latin subsets are
// precached for offline use via the workbox globPatterns in vite.config.ts.
import '@fontsource-variable/fraunces';
import '@fontsource-variable/source-serif-4';
import '@fontsource-variable/source-serif-4/wght-italic.css';
import './index.css';

// Apply the stored theme/accent and follow OS changes while set to "system".
// (index.html applies the same attributes pre-paint; this keeps them live.)
initTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </StrictMode>
);
